import { useSyncExternalStore } from 'react';

/**
 * Видна ли сейчас приветственная заставка (components/Welcom).
 *
 * Приложение рисуется под ней, и всё, что открывает системные окна при
 * старте (запрос геолокации Telegram), должно дождаться её исчезновения —
 * иначе окно всплывает поверх заставки.
 */
let welcomeVisible = false;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const setWelcomeVisible = (visible: boolean) => {
  if (welcomeVisible === visible) return;
  welcomeVisible = visible;
  listeners.forEach(listener => listener());
};

/** true, когда заставки на экране нет (уже исчезла или не показывалась). */
export const useWelcomeDone = () =>
  useSyncExternalStore(subscribe, () => !welcomeVisible);
